module.exports = fox._r("images/promo/icon-li.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/icon-li.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/icon-li.png
// module id = 166
// module chunks = 2